
export function baseHrefFactory() {
  let expectedBaseHref = document.getElementsByTagName('base')[0].attributes[0].nodeValue;
  let currentBaseHref = window.location.pathname.substr(
    0,
    expectedBaseHref.length
  );
  if (
    expectedBaseHref.toLowerCase() === currentBaseHref.toLowerCase() &&
    expectedBaseHref !== currentBaseHref
  ) {
    const newLocation = window.location.href.replace(
      currentBaseHref,
      expectedBaseHref
    );
    window.location.replace(newLocation);
  }
  return expectedBaseHref;
}

export function isPromise<T = any>(obj: any): obj is Promise<T> {
  return !!obj && typeof obj.then === "function";
}